import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import {
  AnalystRatingComponent,
  AnalystRatingTooltipComponent, BuySellButtonsComponent,
  CoreModule,
  DetailedQuoteMessageComponent, DetailedQuoteMoreDetailsComponent, DetailedQuoteSummaryComponent,
  DetailedSymbolHeaderComponent, IfFeatureDirective, IfNoFeatureDirective,
  QuoteChartComponent, QuoteLinkComponent, StarRatingComponent
} from '@tdwb/core';

import { DetailedQuoteComponent } from './detailed-quote.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    FormsModule,
    CoreModule,
    DetailedSymbolHeaderComponent,
    DetailedQuoteMessageComponent,
    QuoteChartComponent,
    QuoteLinkComponent,
    DetailedQuoteSummaryComponent,
    DetailedQuoteMoreDetailsComponent,
    StarRatingComponent,
    AnalystRatingTooltipComponent,
    AnalystRatingComponent,
    BuySellButtonsComponent,
    IfNoFeatureDirective,
    IfFeatureDirective
  ],
  declarations: [
    DetailedQuoteComponent
  ],
  exports: [
    DetailedQuoteComponent
  ]
})
export class QuotesModule {}

export {
  DetailedQuoteComponent
};
